<!--
  APageHead — admin-shared.jsx AdminPageHead 정확 이식
  · 흰 배경(panel) + 하단 1px 라인 + padding 24/32/20
  · 부모(.p-frame__content)가 32px padding을 가지므로 negative margin으로 풀폭 bleed
  · sub 텍스트 영역 없음 (디자인 원본에 없음)
-->
<template>
  <div class="a-page-head">
    <div v-if="breadcrumbs?.length" class="a-page-head__crumbs">
      <template v-for="(b, i) in breadcrumbs" :key="i">
        <component
          :is="b.to ? 'router-link' : 'span'"
          :to="b.to"
          class="a-page-head__crumb"
          :class="{ 'is-last': i === breadcrumbs.length - 1 }"
        >{{ b.label }}</component>
        <span v-if="i < breadcrumbs.length - 1" class="a-page-head__crumb-sep">›</span>
      </template>
    </div>
    <div class="a-page-head__row">
      <h1 class="a-page-head__title">{{ title }}</h1>
      <div v-if="$slots.actions" class="a-page-head__actions"><slot name="actions" /></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'APageHead',
  props: {
    title: { type: String, required: true },
    breadcrumbs: { type: Array, default: () => [] },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_pineapple.scss';

.a-page-head {
  /* 부모 (.p-frame__content) 의 32px padding 을 뚫고 풀폭으로 표시 */
  margin: -32px -32px 32px;
  padding: 24px 32px 20px;
  background: $p-panel;
  border-bottom: 1px solid $p-line;
  font-family: $p-font-body;
  flex-shrink: 0;

  &__crumbs {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    color: $p-ink-soft;
    margin-bottom: 8px;
  }
  &__crumb {
    color: $p-ink-soft;
    font-weight: 500;
    text-decoration: none;

    &.is-last { color: $p-ink; font-weight: 700; }
    &:hover:not(.is-last) { color: $p-ink2; }
  }
  &__crumb-sep { color: $p-ink-softer; }

  &__row {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 16px;
  }
  &__title {
    font-size: 26px;
    font-weight: 900;
    margin: 0;
    letter-spacing: -0.025em;
    line-height: 1.1;
    color: $p-ink;
    white-space: nowrap;
  }
  &__actions {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
  }
}
</style>
